var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0e4dc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073da6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fed443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcd036"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.61904762 0h8.38095238v1.52380952h-8.38095238zm0 3.04761905h8.38095238v1.52380952h-8.38095238zm0 3.04761905h8.38095238v1.52380952h-8.38095238zm-7.61904762 3.04761904h16v1.52380956h-16zm0-9.14285714h7.61904762v7.61904762h-7.61904762z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.80952381 5.32645825-.50861928.75922858-.1288332-.90472295-.78766707.46335968.27646987-.87102584-.91070773.07571671.62701469-.66481138-.85337157-.32692288.85337157-.32692288-.62701469-.66481139.91070773.07571671-.27646987-.87102583.78766707.46335968.1288332-.90472295.50861928.75922858.50861928-.75922858.1288332.90472295.78766707-.46335968-.27646987.87102583.91070773-.07571671-.62701469.66481139.85337157.32692288-.85337157.32692288.62701469.66481138-.91070773-.07571671.27646987.87102584-.78766707-.46335968-.1288332.90472295zm0-.01463263c.80332328 0 1.45454545-.65122218 1.45454545-1.45454545 0-.80332328-.65122217-1.45454546-1.45454545-1.45454546s-1.45454546.65122218-1.45454546 1.45454546c0 .80332327.65122218 1.45454545 1.45454546 1.45454545zm0-.35944467c-.63118257 0-1.14285714-.51167457-1.14285714-1.14285714s.51167457-1.14285714 1.14285714-1.14285714 1.14285714.51167457 1.14285714 1.14285714-.51167457 1.14285714-1.14285714 1.14285714z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.14285714 3.80952381c0-.05259855.04263955-.0952381.0952381-.0952381.05259854 0 .09523809.04263955.09523809.0952381 0 .08092299.02013014.15871683.05802822.22803603.08299034.1517972.24205224.24815445.41816226.24815445.1852089 0 .35113714-.10664687.42975805-.27078451.01464792-.02876343.01464792-.02876343.02918621-.05361056.00524267-.00883529.00524267-.00883529.01027347-.01727351.03632568-.06104031.04756984-.09017016.04756984-.1345219 0-.05259855.04263955-.0952381.0952381-.0952381s.09523809.04263955.09523809.0952381c0 .08699976-.02194555.14385332-.07436196.23193188-.00513385.00861162-.00513385.00861162-.0099721.0167653-.01216893.0208619-.01216893.0208619-.0213856.03899324-.11000096.22965009-.34233247.37897625-.6015441.37897625-.24644656 0-.46922058-.13495308-.58529158-.34725795-.05312197-.09716512-.08137509-.20635063-.08137509-.31940872zm1.04761905-.19047619c-.1051971 0-.19047619-.08527909-.19047619-.19047619s.08527909-.19047619.19047619-.19047619.19047619.08527909.19047619.19047619-.08527909.19047619-.19047619.19047619zm-.76190476 0c-.1051971 0-.19047619-.08527909-.19047619-.19047619s.08527909-.19047619.19047619-.19047619.19047619.08527909.19047619.19047619-.08527909.19047619-.19047619.19047619z",
    fill: "#c6a326",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/UY.7e085f4ab1fb3452c667cdb23746a087.svg";
export { ForwardRef as ReactComponent };